import { render, staticRenderFns } from "./ConferenceRoomBookings.vue?vue&type=template&id=1b52f288&"
import script from "./ConferenceRoomBookings.vue?vue&type=script&lang=js&"
export * from "./ConferenceRoomBookings.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports